import React, { useEffect, useState } from "react";
import { collection, getDocs, doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { Alert, Badge, Card, Form, Spinner } from "react-bootstrap";

import { db } from "../../../../shared/libs/firebaseConfig";
import { AFFILIATE_COLLECTIONS, AFFILIATE_STATUSES } from "../../../../shared/utils/affiliateSchema";

const STATUS_OPTIONS = [
  AFFILIATE_STATUSES.approved,
  AFFILIATE_STATUSES.suspended,
  AFFILIATE_STATUSES.rejected,
];

export default function AdminAffiliates() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updatingId, setUpdatingId] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const loadItems = async () => {
    try {
      setLoading(true);
      setError("");
      const snap = await getDocs(collection(db, AFFILIATE_COLLECTIONS.affiliates));
      const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      rows.sort((a, b) => String(a?.code || "").localeCompare(String(b?.code || "")));
      setItems(rows);
    } catch (e) {
      console.error(e);
      setError(e?.message || "โหลดรายชื่อ Affiliate ไม่สำเร็จ");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadItems();
  }, []);

  const updateStatus = async (item, status) => {
    if (!item?.id) return;
    try {
      setUpdatingId(item.id);
      setError("");
      setSuccess("");
      await updateDoc(doc(db, AFFILIATE_COLLECTIONS.affiliates, item.id), {
        status,
        updatedAt: serverTimestamp(),
      });
      setItems((prev) => prev.map((x) => (x.id === item.id ? { ...x, status } : x)));
      setSuccess("อัปเดตสถานะ Affiliate แล้ว");
    } catch (e) {
      console.error(e);
      setError(e?.message || "อัปเดตสถานะไม่สำเร็จ");
    } finally {
      setUpdatingId("");
    }
  };

  return (
    <div>
      <h4 className="mb-1">Affiliates</h4>
      <div className="text-muted small mb-3">จัดการสถานะ Affiliate ที่ได้รับอนุมัติแล้ว</div>

      {error ? <Alert variant="danger">{error}</Alert> : null}
      {success ? <Alert variant="success">{success}</Alert> : null}

      {loading ? (
        <div className="py-4 text-center text-muted">
          <Spinner animation="border" size="sm" /> กำลังโหลด...
        </div>
      ) : items.length === 0 ? (
        <Card className="border">
          <Card.Body className="text-center text-muted py-5">ยังไม่มี Affiliate</Card.Body>
        </Card>
      ) : (
        <div className="d-flex flex-column gap-3">
          {items.map((item) => (
            <Card key={item.id} className="border">
              <Card.Body>
                <div className="d-flex align-items-start justify-content-between gap-3">
                  <div>
                    <div className="fw-semibold">{item?.profile?.displayName || item.userId || "-"}</div>
                    <div className="text-muted small">
                      Code: <code>{item.code || "-"}</code>
                    </div>
                    <div className="text-muted small">{item?.contact?.email || "-"}</div>
                  </div>
                  <Badge bg={item.status === AFFILIATE_STATUSES.approved ? "success" : "secondary"}>
                    {item.status || "-"}
                  </Badge>
                </div>

                <div className="mt-3" style={{ maxWidth: 280 }}>
                  <Form.Label>สถานะ</Form.Label>
                  <Form.Select
                    value={item.status || AFFILIATE_STATUSES.approved}
                    onChange={(e) => updateStatus(item, e.target.value)}
                    disabled={updatingId === item.id}
                  >
                    {STATUS_OPTIONS.map((status) => (
                      <option key={status} value={status}>
                        {status}
                      </option>
                    ))}
                  </Form.Select>
                </div>
              </Card.Body>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
